<script>
	const page = require('page');
	const studentProgressUtilities = require('utilities/studentProgressUtilities');
	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const teacherGetArticlesRead = studentLibraryUtilities.teacherGetArticlesRead;

	module.exports = {
		components: {
			'load-mask': require('components/load-mask.vue').default,
			'library-product-card': require('components/library-product-card.vue').default
		},
		props: {
			studentName: {
				default: ''
			},
			loading: {
				default: false
			}
		},
		modelData: {
			classCode: 'classCode',
			studentId: 'studentId',
			teacherLibraryResults: 'teacherLibraryResults',
			studentProgressMonth: 'month'
		},
		data() {
			return {
				libraryLoading: false,
				month: ''
			};
		},
		computed: {
			viewLoading() {
				let loading = this.loading;
				let libraryLoading = this.libraryLoading;
				return loading || libraryLoading;
			},
			results() {
				let uid = this.studentId;
				let teacherLibraryResults = this.teacherLibraryResults;
				let studentResults = [];
				let startDate = this.startDate;
				let endDate = this.endDate;

				if (uid && teacherLibraryResults && teacherLibraryResults[uid]) {
					studentResults = [...teacherLibraryResults[uid]];
					if (startDate !== 'all' && endDate) {
						studentResults = studentResults.filter(r => {
							let created = r.c * 1000;
							return created >= startDate && created <= endDate;
						});
					}
					studentResults.sort((a, b) => (a.c < b.c ? 1 : -1));
				}

				return studentResults;
			},
			articlesReadNumber() {
				let results = this.results;
				return results.length;
			},
			wordCount() {
				let results = this.results;
				let count = 0;
				results.forEach(r => (count += r.wordCount));

				return count;
			},
			startDate: function () {
				let month = this.month;
				return studentProgressUtilities.getStartDate(month);
			},
			endDate: function () {
				let month = this.month;
				let endDate = studentProgressUtilities.getEndDate(month);
				let now = new Date().getTime();

				if (endDate > now) {
					endDate = now;
				}

				return endDate;
			}
		},
		methods: {
			onProductClick(event, pid) {
				page('/article/' + pid);
			}
		},
		watch: {
			studentId(uid) {
				let cc = this.classCode;
				if (cc && uid) {
					this.libraryLoading = true;
					teacherGetArticlesRead(cc, uid).finally(() => (this.libraryLoading = false));
				}
			}
		},
		mounted() {
			this.month = this.month || studentProgressUtilities.getCurrentMonth();
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.student-library-individual-results {
		position: relative;

		.stat-row {
			display: flex;
			justify-content: flex-end;
			margin-bottom: 2rem;

			.stat {
				display: inline-block;
				margin-right: 1rem;

				.top-stat {
					text-align: left;
					font-weight: bold;
					font-size: 1.25rem;
				}

				.bottom-stat {
					font-size: 0.75rem;
				}
			}
		}

		.library-results-table-header {
			margin: 1rem 0;
			padding-bottom: 1rem;
			font-weight: bold;
			border-bottom: 1px solid $c-grey;
		}

		.library-result-row {
			display: flex;
			align-items: center;
			margin-bottom: 1rem;
			padding-bottom: 1rem;
			border-bottom: 1px solid $c-grey;

			.article-read {
				flex: 2;
			}

			.notes-added {
				flex: 4;
			}

			.date-read {
				flex: 1;
			}
		}

		.library-product-card.horizontal {
			margin: 0;

			.product-image .article-image .article-featured-image-container {
				width: 7rem;
				height: 7rem;
			}

			.product-body {
				display: flex;
				flex-direction: column;
				justify-content: center;
			}
		}
	}

	@media print {
		.student-library-individual-results {
			a.product-title {
				display: inherit !important;

				&:after {
					display: none;
				}
			}
		}
	}
</style>
<template>
	<div class="student-library-individual-results">
		<load-mask v-if="viewLoading"></load-mask>
		<div class="library-results-body margin-top-medium">
			<div class="stat-row">
				<div class="stat">
					<div class="top-stat">
						{{ articlesReadNumber }}
					</div>
					<div class="bottom-stat">Articles Read</div>
				</div>
				<div class="stat">
					<div class="top-stat">
						{{ wordCount | commaGrouping }}
					</div>
					<div class="bottom-stat">Words Read</div>
				</div>
			</div>
			<div class="library-results-table">
				<div class="library-results-table-header library-result-row">
					<div class="table-header date-read">Date Read</div>
					<div class="table-header article-read">Article Read</div>
					<div class="table-header notes-added">Notes Added</div>
				</div>
				<div
					class="library-results-table-body"
					v-if="results && results.length">
					<div
						class="library-result-row"
						v-for="(item, index) in results"
						:key="item.id">
						<div class="date-read">
							<span>{{ item.c | dateShort }}</span>
						</div>
						<div class="article-read">
							<library-product-card
								:id="item.id"
								:img="item.img_highres2"
								:img-alt="item.imgAlt"
								:title="item.title"
								:show-reading-list="false"
								:horizontal="true"
								:versioned="true"
								:link="false"
								:on-product-click="onProductClick"
								:article-index="index"
								:level="((item.canonicalGrade && [item.canonicalGrade]) || item.grades) | getGradeRangeString">
							</library-product-card>
						</div>
						<div
							class="notes-added"
							:class="{
								'text-muted': !item.n,
								'text-italic': !item.n
							}">
							{{ item.n || 'No note added.' }}
						</div>
						<!-- {{item.title}} - {{ item.p }} - {{item.n}} -->
					</div>
				</div>
				<div
					class="library-results-empty"
					v-if="!viewLoading && results.length < 1">
					<p>{{ studentName ? studentName : 'This student' }} hasn't read anything from the library.</p>
				</div>
			</div>
		</div>
	</div>
</template>
